// removed by extract-text-webpack-plugin
module.exports = {"check-box-wrap":"check-box-wrap","check-box":"check-box","lb-check-box":"lb-check-box"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/checkbox/style.scss
// module id = ./components/partials/checkbox/style.scss
// module chunks = 0